import * as Actions from '../actions/brand.actions';

const initialState = {
	knownBrands: null,
};

export const brandReducer = (state = initialState, action) => {
	const { type, payload } = action;

	switch (type) {
		case Actions.GET_ALL_KNOWN_BRANDS:
			return (state = {
				...state,
				knownBrands: payload,
			});
		default:
			return state;
	}
};
